import { createTheme } from '@mantine/core';
import { mtbThemeOverride } from '@mtb/theme';

/**
 * The app's Mantine theme.
 *
 * Shell: all three (management, show, kiosk) — one Vite build, one theme.
 *
 * Everything here comes from `@mtb/theme`, which re-exports the generated
 * artifact in the workspace-root `mtb-design-system/` checkout. **Do not add local
 * overrides to this file.** A value that needs to change is a design-system
 * change: edit `tokens.json` there, regenerate, then `pnpm theme:sync`. That is
 * the whole point — this file used to carry its own hand-copied Mint ramp,
 * citing a `mtb-storefront/project/theme.css` design bundle that exists in no
 * repo, and the palette drifted exactly because of it.
 *
 * The theme is only half of the styling contract. `main.tsx` also imports
 * `@mtb/theme/styles.css` (tokens) and `@mtb/theme/mantine-bridge.css` (which
 * points Mantine's CSS variables at those tokens), and `index.html` carries
 * `data-scheme` / `data-density` on `<html>`. All four are required.
 *
 * Accessibility note: `mtbThemeOverride` sets `autoContrast: true` with
 * `luminanceThreshold: 0.25`, which is what makes filled primary buttons legal.
 * Mint-600 (`#0FA882`) has a relative luminance of 0.2972; Mantine picks a
 * black label only when luminance exceeds the threshold, so at Mantine's stock
 * 0.3 the label stays white at **3.02:1** and fails WCAG AA. At 0.25 it
 * resolves to near-black at **6.62:1**. Raising that number silently
 * reintroduces the defect.
 */
export const theme = createTheme(mtbThemeOverride);
